import { createApp } from 'vue'
import App from './BigBoss.vue'
createApp(App).mount('#app')

